/**
 * Ironside · Preventa — line item property "fecha_preventa"
 *
 * 1. Mantiene sincronizado el input oculto `properties[fecha_preventa]` con la
 *    variante seleccionada en cada formulario de add-to-cart.
 * 2. Intercepta las llamadas a /cart/add (FormData, URLSearchParams y JSON) para
 *    inyectar la propiedad incluso cuando el add-to-cart no envía el formulario
 *    (quick add en lote, carrusel de vistos recientemente, apps de terceros).
 *
 * El valor es la fecha cruda del metafield custom.disponibilidad_de_preventa.
 */
(function () {
  if (window.__ironsidePreorderCartLoaded) return;
  window.__ironsidePreorderCartLoaded = true;

  var PROPERTY_NAME = 'fecha_preventa';
  var PROPERTY_KEY = 'properties[' + PROPERTY_NAME + ']';
  var SKU_PROPERTY_NAME = 'sku';
  var SKU_PROPERTY_KEY = 'properties[' + SKU_PROPERTY_NAME + ']';
  var WEIGHT_PROPERTY_NAME = 'peso';
  var WEIGHT_PROPERTY_KEY = 'properties[' + WEIGHT_PROPERTY_NAME + ']';
  var STORAGE_KEY = 'ironside:preorder-dates';
  var STORAGE_LIMIT = 300;

  /** @type {Record<string, string>} variantId -> fecha ISO */
  var registry = (window.__ironsidePreorderDates = window.__ironsidePreorderDates || {});

  function normalize(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  /**
   * El metafield es de tipo `date`. Liquid ya lo emite como YYYY-MM-DD, pero los
   * badges de preventa preexistentes pueden exponerlo con hora/zona horaria.
   * Se recorta a ISO para que el valor sea idéntico venga de donde venga.
   */
  function normalizeDate(value) {
    var raw = normalize(value);
    var match = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    return match ? match[1] : raw;
  }

  /* --------------------------------------------------------- persistencia */
  /* Permite que carruseles renderizados por JS (ej. "vistos recientemente"),
     que agregan al carrito sin formulario, sigan resolviendo la fecha de una
     variante vista en una página anterior. */

  function readStorage() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      if (!parsed || typeof parsed !== 'object') return;
      for (var id in parsed) {
        if (!Object.prototype.hasOwnProperty.call(parsed, id)) continue;
        var storedEntry = parsed[id];
        var storedDate = normalizeDate(
          storedEntry && typeof storedEntry === 'object' ? storedEntry.date : storedEntry
        );
        var storedSku = normalize(storedEntry && typeof storedEntry === 'object' ? storedEntry.sku : '');
        var storedWeight = normalize(
          storedEntry && typeof storedEntry === 'object' ? storedEntry.weight : ''
        );
        if (!registry[id] && (storedDate || storedSku || storedWeight)) {
          registry[id] = {
            date: storedDate,
            sku: storedSku,
            weight: storedWeight
          };
        }
      }
    } catch (error) {
      /* localStorage no disponible */
    }
  }

  function writeStorage() {
    try {
      var ids = Object.keys(registry);
      if (ids.length > STORAGE_LIMIT) ids = ids.slice(ids.length - STORAGE_LIMIT);
      var out = {};
      for (var i = 0; i < ids.length; i++) out[ids[i]] = registry[ids[i]];
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(out));
    } catch (error) {
      /* cuota llena o modo privado */
    }
  }

  /* ---------------------------------------------------------------- registro */

  function collect() {
    var payloads = document.querySelectorAll('script[data-ironside-preorder-dates]');
    for (var i = 0; i < payloads.length; i++) {
      var data;
      try {
        data = JSON.parse(payloads[i].textContent || '{}');
      } catch (error) {
        continue;
      }
      var fallback = normalizeDate(data.default);
      var variants = data.variants || {};
      for (var id in variants) {
        if (!Object.prototype.hasOwnProperty.call(variants, id)) continue;
        var entry = variants[id];
        var date = normalizeDate(entry && typeof entry === 'object' ? entry.date : entry) || fallback;
        var sku = normalize(entry && typeof entry === 'object' ? entry.sku : '');
        var weight = normalize(entry && typeof entry === 'object' ? entry.weight : '');
        if (date || sku || weight) {
          registry[String(id)] = {
            date: date,
            sku: sku,
            weight: weight
          };
        }
      }
    }

    // Reutiliza los mapas que ya exponen los badges de preventa del tema.
    var badges = document.querySelectorAll('[data-variant-dates]');
    for (var j = 0; j < badges.length; j++) {
      var list;
      try {
        list = JSON.parse(badges[j].getAttribute('data-variant-dates') || '[]');
      } catch (error) {
        continue;
      }
      if (!Array.isArray(list)) continue;
      var productDate = normalizeDate(badges[j].getAttribute('data-product-date'));
      for (var k = 0; k < list.length; k++) {
        var entry = list[k] || {};
        var entryDate = normalizeDate(entry.date) || productDate;
        if (entry.id && entryDate) {
          var badgeEntry = registry[String(entry.id)] || {};
          registry[String(entry.id)] = {
            date: entryDate,
            sku: normalize(badgeEntry.sku),
            weight: normalize(badgeEntry.weight)
          };
        }
      }
    }

    writeStorage();
  }

  function dateFor(variantId) {
    var id = normalize(variantId);
    if (!id) return '';
    var entry = registry[id];
    if (entry && typeof entry === 'object') return normalizeDate(entry.date);
    return normalizeDate(entry);
  }

  function skuFor(variantId) {
    var id = normalize(variantId);
    if (!id) return '';
    var entry = registry[id];
    return entry && typeof entry === 'object' ? normalize(entry.sku) : '';
  }

  function weightFor(variantId) {
    var id = normalize(variantId);
    if (!id) return '';
    var entry = registry[id];
    return entry && typeof entry === 'object' ? normalize(entry.weight) : '';
  }

  /* ------------------------------------------------------- inputs ocultos */

  function syncInputs() {
    var inputs = document.querySelectorAll(
      'input[data-ironside-preorder-property], input[data-ironside-sku-property], input[data-ironside-weight-property]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var form = input.form || input.closest('form');
      var variantField = form ? form.querySelector('[name="id"]') : null;
      var variantId = variantField ? variantField.value : '';
      var isSkuInput = input.hasAttribute('data-ironside-sku-property');
      var isWeightInput = input.hasAttribute('data-ironside-weight-property');
      var value;
      if (isSkuInput) {
        value = variantId ? skuFor(variantId) : normalize(input.value);
      } else if (isWeightInput) {
        value = variantId ? weightFor(variantId) : normalize(input.value);
      } else {
        value = variantId ? dateFor(variantId) : normalizeDate(input.value);
      }

      input.value = value;
      // Un input deshabilitado no se serializa: evita enviar la propiedad vacía.
      input.disabled = !value;
    }
  }

  function refresh() {
    collect();
    syncInputs();
  }

  var refreshTimer = null;
  function refreshSoon() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 80);
  }

  /* --------------------------------------------------- interceptor de red */

  function isCartAdd(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (error) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
    }
  }

  /** FormData y URLSearchParams comparten la misma API get/set/delete. */
  function applyToEntries(body) {
    // Formularios multi-variante (quick order list) se resuelven por la vía JSON.
    if (typeof body.getAll === 'function' && body.getAll('id').length !== 1) return body;
    var variantId = body.get('id');
    var date = dateFor(variantId);
    var sku = skuFor(variantId);
    var weight = weightFor(variantId);
    if (date) {
      if (!normalize(body.get(PROPERTY_KEY))) body.set(PROPERTY_KEY, date);
    } else {
      body.delete(PROPERTY_KEY);
    }
    if (sku) {
      if (!normalize(body.get(SKU_PROPERTY_KEY))) body.set(SKU_PROPERTY_KEY, sku);
    } else {
      body.delete(SKU_PROPERTY_KEY);
    }
    if (weight) {
      if (!normalize(body.get(WEIGHT_PROPERTY_KEY))) body.set(WEIGHT_PROPERTY_KEY, weight);
    } else {
      body.delete(WEIGHT_PROPERTY_KEY);
    }
    return body;
  }

  function applyToItem(item) {
    if (!item || !item.id) return item;
    var properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
    var date = dateFor(item.id);
    var sku = skuFor(item.id);
    var weight = weightFor(item.id);
    if (date && !normalize(properties[PROPERTY_NAME])) properties[PROPERTY_NAME] = date;
    if (sku && !normalize(properties[SKU_PROPERTY_NAME])) properties[SKU_PROPERTY_NAME] = sku;
    if (weight && !normalize(properties[WEIGHT_PROPERTY_NAME])) properties[WEIGHT_PROPERTY_NAME] = weight;
    if (!date && !sku && !weight) return item;
    item.properties = properties;
    return item;
  }

  function applyToPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (Array.isArray(payload.items)) {
      payload.items.forEach(applyToItem);
    } else {
      applyToItem(payload);
    }
    return payload;
  }

  function getCartJsonUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }
    return Theme.routes.cart_url + '.js';
  }

  function reconcileExistingCartProperties() {
    if (!document.querySelector('[data-ironside-cart-items]')) return;

    var skuByKey = {};
    var weightByKey = {};
    var cartRows = document.querySelectorAll('[data-ironside-cart-line]');
    for (var i = 0; i < cartRows.length; i++) {
      var row = cartRows[i];
      skuByKey[row.getAttribute('data-ironside-cart-line')] = normalize(
        row.getAttribute('data-ironside-variant-sku')
      );
      weightByKey[row.getAttribute('data-ironside-cart-line')] = normalize(
        row.getAttribute('data-ironside-variant-weight')
      );
    }

    fetch(getCartJsonUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return [];

        var changes = [];
        for (var j = 0; j < cart.items.length; j++) {
          var item = cart.items[j];
          var properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
          var currentSku = normalize(properties[SKU_PROPERTY_NAME]);
          var currentWeight = normalize(properties[WEIGHT_PROPERTY_NAME]);
          var itemKey = normalize(item.key);
          var sku = normalize(item.sku) || skuByKey[itemKey] || skuFor(item.variant_id);
          var weight = weightByKey[itemKey] || weightFor(item.variant_id);

          if ((currentSku || !sku) && (currentWeight || !weight)) continue;
          if (!currentSku && !sku && !currentWeight && !weight) continue;

          var nextProperties = {};
          for (var propertyName in properties) {
            if (Object.prototype.hasOwnProperty.call(properties, propertyName)) {
              nextProperties[propertyName] = properties[propertyName];
            }
          }
          if (!currentSku && sku) nextProperties[SKU_PROPERTY_NAME] = sku;
          if (!currentWeight && weight) nextProperties[WEIGHT_PROPERTY_NAME] = weight;

          changes.push(
            fetch(Theme.routes.cart_change_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                id: itemKey || item.variant_id,
                quantity: item.quantity,
                properties: nextProperties
              })
            })
          );
        }

        return Promise.all(changes);
      })
      .then(function (changes) {
        if (!changes || changes.length === 0) return;
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: {} }
          })
        );
      })
      .catch(function () {
        /* nunca bloquear la navegación del carrito */
      });
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isCartAdd(url) && init && init.body) {
          readStorage();
          collect();
          var body = init.body;

          if (typeof FormData !== 'undefined' && body instanceof FormData) {
            applyToEntries(body);
          } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
            applyToEntries(body);
          } else if (typeof body === 'string') {
            try {
              var parsed = JSON.parse(body);
              init = Object.assign({}, init, { body: JSON.stringify(applyToPayload(parsed)) });
            } catch (error) {
              /* cuerpo no JSON: se envía sin modificar */
            }
          }
        }
      } catch (error) {
        /* nunca bloquear el add-to-cart */
      }

      return nativeFetch.call(this, input, init);
    };
  }

  /* -------------------------------------------------------------- eventos */

  function onReady() {
    readStorage();
    refresh();
    reconcileExistingCartProperties();

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('form')) refreshSoon();
    });
    document.addEventListener('cart:add', function () {
      window.setTimeout(reconcileExistingCartProperties, 0);
    });
    document.addEventListener('variant:update', refreshSoon);
    document.addEventListener('variant:change', refreshSoon);
    document.addEventListener('shopify:section:load', refreshSoon);
    window.addEventListener('popstate', refreshSoon);

    // Quick add modal, secciones re-renderizadas y carruseles inyectan HTML nuevo.
    if (typeof MutationObserver !== 'undefined' && document.body) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
            refreshSoon();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
